import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import {
  SolicitudReutilizacionControllerService,
  UsuarioSDDRCaDTO,
  EntidadCertificadoDTO
} from 'api-rest';
import { Combo, ComboService } from '../../../services/combo.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { ValidateService } from '../../../services/validate.service';
import { zip } from 'rxjs';
import Swal from 'sweetalert2';
import moment from 'moment';
import { ParseCurrencyPipe } from '../../../share/pipe/ParseCurrency.pipe';
import { FormatCurrencyPipe } from '../../../share/pipe/FormatCurrency.pipe';


@Component({
  selector: 'open-ssdr-reuse-certificate-dialog',
  templateUrl: './open-ssdr-reuse-certificate-dialog.component.html',
  styleUrls: ['./open-ssdr-reuse-certificate-dialog.component.scss']
})
export class OpenSsdrReuseCertificateDialogComponent implements OnInit {
  formGroup!: FormGroup;

  tiposUsusariosSddr!: UsuarioSDDRCaDTO[];
  listaUsusariosSddr = this.environment.urlBackCore + 'api/v1/poseedores/poseedor';
  selectUsuarioSddr: any;

  updateList: boolean = false;
  defaultGestoresParameters = { 'estado.id': 4 };
  anios: number[] = [];
  usuario: any;

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<OpenSsdrReuseCertificateDialogComponent>,
    public spinnerSrv: SpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private comboSrv: ComboService,
    private snackBarSrv: SnackbarService,
    @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService,
    private validateSrv: ValidateService,
    private solicitudReutilizacionCtrlSrv: SolicitudReutilizacionControllerService,
    private downloadSrv: DownloadService
  ) {
    const currentYear = new Date().getFullYear();
    this.formGroup = this.formBuilder.group({
      usuarioSddr: [null, [Validators.required]],
      anyo: [currentYear, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.cargarCombos();
    this.formGroup.get('usuarioSddr')?.valueChanges.subscribe(() => {
      this.obtenerUsuarioSddrSeleccionado();
    }
    );    
  }


  cargarCombos(): void {
    this.spinnerSrv.loadingShow();
    this.solicitudReutilizacionCtrlSrv.findAllUsuariosAsociados().subscribe({
      next: (resp) => {
        this.spinnerSrv.loadingHide();
        this.tiposUsusariosSddr = resp;
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
      },
    });
  }


  cerrar(): void {
    this.spinnerSrv.loading = 0;
    this.dialogRef.close(null);
  }
 
 
  generarCertificado(){
    if (this.esFormularioValido() && this.formGroup.get('usuarioSddr')?.value) {
      if (this.usuario) {
        let filter: EntidadCertificadoDTO;
        filter = {
          poseedor: {
            id: this.usuario.id
          },
          anno: this.formGroup.get('anyo')?.value
        }
        
        this.solicitudReutilizacionCtrlSrv.generarCertificado(filter).subscribe({
          next: (resp) => {
            this.spinnerSrv.loadingHide();
            this.downloadSrv.downloadBlob(resp, 'Certificado.pdf');
            this.snackBarSrv.showSnackBar("Certificado generado correctamente.", "success");
            this.cerrar();
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
            let errorMessage = "Ha ocurrido un error al generar el certificado.";
            if(err?.cause){
              errorMessage = errorMessage + err?.cause;
            }
            this.snackBarSrv.showSnackBar(errorMessage, "error");
            this.cerrar();
          },
        });
      }
    }
    
  }


  esFormularioValido(): boolean {
    let valid = false;
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) { 
      valid = true;
    }
    return valid;
  }


  controlHasError(controlName: string, errorName: string, form: FormGroup) {
    return (
      form.controls[controlName]?.hasError(errorName) &&
      form.controls[controlName]?.touched
    );
  }

  formatoValidator() {
    return (control: FormControl) => {
      const valor = control.value;
      if (!valor) {
        return null;
      }
      const regex = /^ENV\/\d{4}\/\d{9}$/;
      if (!regex.test(valor)) {
        return { formatoInvalido: true };
      }

      if (valor.length !== 18) {
        return { longitudIncorrecta: true };
      }

      return null;
    };
  }

  canAccessAll(list: any) {
    const resultDelete = this.canAccessEdit();
    const listPermission = list.map((objeto: any) => {
      return {
        ...objeto
      };
    });
    return listPermission;
  }
  canAccessEdit(): boolean {
    return this.authService.can('sddr-ca-solicitudes-reutilizacion-detalle', 'edit');
  }
  canAccessGuardar(): boolean {
    return this.authService.can('sddr-ca-solicitudes-reutilizacion-detalle', 'access-b-guardar');
  }
  canAccessGuardarEnviar(): boolean {
    return this.authService.can('sddr-ca-solicitudes-reutilizacion-detalle', 'access-b-guardar-enviar');
  }
  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.formGroup.get(formName)?.setValue(null);
  }
  showClearButton(formName: string): boolean {
    return this.formGroup.get(formName)?.value !== null;
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'usuarioSddr': {
        return this.formGroup.get('usuarioSddr') as FormControl;
      }
      default: {
        return this.formGroup.get('') as FormControl;
      }
    }
  }

  getPoseedorDescription(obj: any) {
      const parts = [
      obj?.razonSocial,
      obj?.nima,
      obj?.denominacionCentro
    ].filter(Boolean);
    return parts.join(' - ');
  }

  getPoseedorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: `${searchterm}`,
      'estado.id': 4,
    };
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  obtenerUsuarioSddrSeleccionado(): any {
        let usuario;
    if (this.canViewResource('SDDR-CA-ENV-GEST') || this.canViewResource('SDDR-CA-ENV-CONS')) {
      usuario = this.formGroup.get('usuarioSddr')?.value
    } else {
      usuario = this.tiposUsusariosSddr.find((x: UsuarioSDDRCaDTO) => (x.id! + x.tipoUsuario!) === this.formGroup.get('usuarioSddr')?.value);
    }
    this.usuario = usuario;
    this.obtenerAnnosDisponibles();

  }

  obtenerAnnosDisponibles(): void {
    this.spinnerSrv.loadingShow();
    let filter: EntidadCertificadoDTO;
    filter = {
      poseedor: {
        id: this.usuario.id
      }
    }
    this.solicitudReutilizacionCtrlSrv.getAnnosDisponibles(filter).subscribe({
      next: (resp) => {
        this.spinnerSrv.loadingHide();
        this.anios = resp;
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
      },
    });
  }
}
